// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ClaimIcon_wrapper__2R3B-","icon-wrapper":"ClaimIcon_icon-wrapper__RzMy3","highLight":"ClaimIcon_highLight__33moM","title":"ClaimIcon_title__2qAKb"};